<template>
  <section class="pub-mapinspect">
    <v-login-info></v-login-info>

    <div class="form-content">
      <h1 class="map-title">地图MOD正式区审核</h1>
      <form action="javascript: void(0)">
        <dl class="form-box">
          <dt class="title">地图ID：</dt>
          <dd class="content">{{ mapInfo.MapId }}</dd>
        </dl>

        <dl class="form-box">
          <dt class="title">地图名字：</dt>
          <dd class="content">
            <input name="mapName" class="map-name" type="text" v-model="mapName" v-validate="'required'" />
          </dd>
        </dl>

        <!--<dl class="form-box game-type-box">
          <dt class="title">游戏类型：</dt>
          <dd class="content">
            <select id="game-type" name="game-type" class="select-type" v-model="mapType">
              <option value="1" selected="selected">体育</option>
              <option value="2">竞技</option>
              <option value="4">策略</option>
              <option value="5">动作</option>
              <option value="6">塔防</option>
              <option value="7">格斗</option>
              <option value="8">跑酷</option>
              <option value="9">音乐</option>
              <option value="10">休闲</option>
              <option value="11">解谜</option>
              <option value="12">竞速</option>
              <option value="13">射击</option>
              <option value="14">模拟经营</option>
              <option value="15">棋牌</option>
              <option value="16">角色扮演</option>
              <option value="17">儿童</option>
              <option value="18">养成</option>
            </select>
          </dd>
        </dl>-->

        <dl class="form-box form-box-tag clearfix">
          <dt class="title">游戏标签：</dt>
          <dd class="tag-content clearfix">
            <ul class="tag-list-box">
              <li class="tag" v-for="(item, index) in tags">
                {{item}}
                <a class="close-btn" href="javascript: void(0)" @click="delTagFn(index)">
                  <i class="icon-close"></i>
                </a>
              </li>
            </ul>

            <div class="add-tag-box" v-show="tagAddFlag">
              <input class="add-tag-input" type="text" maxlength="3" v-model="tagVal" ref="addTagInput" @keyup.enter="addTagFn" />
              <a class="add-tag-btn" href="javascript: void(0)" @click="addTagFn">添加</a>
            </div>

            <p class="tag-desc">可以填写最多三个标签，每个标签3个字</p>
          </dd>
        </dl>

        <dl class="form-box game-desc clearfix">
          <dt class="title">游戏介绍：</dt>
          <dd class="content">
            <textarea name="gameDesc" class="desc" maxlength="500" v-model="mapDesc" v-validate="'required'">游戏介绍</textarea>
          </dd>
        </dl>

        <dl class="form-box game-desc clearfix">
          <dt class="title">更细内容：</dt>
          <dd class="content">
            <textarea name="contentUpdate" class="desc" maxlength="300" v-model="mapUpdate">更细介绍</textarea>
          </dd>
        </dl>

        <!--<dl class="form-box">
          <dt class="title">付费下载：</dt>
          <dd class="content">
            <select id="payDown" name="payDown" class="select-type">
              <option value="1" selected="selected">免费下载</option>
              <option value="2">10创造币</option>
              <option value="4">30创造币</option>
            </select>
            <p class="pay-down-desc">推荐免费下载可以获得更多的玩家参与</p>
          </dd>
        </dl>-->

        <p class="main-ganme-desc">
          <span>游戏主图：</span>
          请上传1张截图支持JPG格式。截图尺寸要求：必须为306*172，单张图片不能超过1M。
          <a class="demo" href="javascript: void(0)" @click="demo1Fn">
            查看示例
            <img v-show="demoFlag1" class="demo-image1" src="./img/demo-image.png" alt="示例"/>
          </a>
        </p>

        <div class="game-pic">
          <ul class="pic-list-box pic-list1 clearfix">
            <li class="item" @click="picUploadFn($event, 0)">
              <div class="item-pic-box">
                <img class="item-pic hook-item-pic upload-images" :src="picList[0].picture ? picList[0].picture : defaultPic" alt="上传主图"/>
                <vue-core-image-upload
                v-show="!picList[0].picture"
                class="upload-pic-btn pic-btn"
                text="上传图片"
                @imageuploaded="imageuploaded"
                @imageuploading="imageuploading"
                @errorhandle="errorhandle"
                :data="picData"
                inputOfFile="FileName"
                extensions="jpg"
                inputAccept="image/jpg,image/jpeg"
                crop="local"
                :maxWidth="306"
                :maxHeight="172"
                cropRatio="16:9"
                :url="`${$api.upload}/Developer/UploadFile`" >
                </vue-core-image-upload>
                <a class="del-pic-btn pic-btn" href="javascript: void(0)" v-show="picList[0].picture" @click="delPicFn(0)">删除图片</a>
                <span class="upload-image-loading" v-show="imageLoadingFlag">
                  <img class="loading-svg" src="/static/loading/loading-spinning-bubbles.svg" alt="加载中"/>
                </span>
              </div>
            </li>
            <li class="item"></li>
            <li class="item"></li>
          </ul>

          <div class="pic-list">
            <p class="pic-desc">游戏截图：请上传3—5张截图。</p>
            <p class="pic-desc pic-demo-box">
              <span>截请上传3-5张截图支持JPG格式。截图尺寸要求：必须为800*450，单张图片不能超过1M。</span>
              <a class="demo" href="javascript: void(0)" @click="demo2Fn">
                查看示例
                <img v-show="demoFlag2" class="demo-image2" src="./img/demo-image.png" alt="示例"/>
              </a>
            </p>

            <ul class="pic-list-box pic-list1 clearfix">
              <li class="item" @click="picUploadFn($event, 1)">
                <div class="item-pic-box">
                  <img class="item-pic hook-item-pic upload-images" :src="picList[1].picture ? picList[1].picture : defaultPic" alt="游戏截图"/>
                  <vue-core-image-upload
                  v-show="!picList[1].picture"
                  class="btn btn-primary upload-pic-btn pic-btn"
                  text="上传图片"
                  @imageuploaded="imageuploaded"
                  @errorhandle="errorhandle"
                  :data="picData"
                  :maxFileSize="1048576"
                  inputOfFile="FileName"
                  extensions="jpg"
                  inputAccept="image/jpg,image/jpeg"
                  crop="local"
                  :maxWidth="800"
                  :maxHeight="450"
                  cropRatio="16:9"
                  :url="`${$api.upload}/Developer/UploadFile`" >
                  </vue-core-image-upload>
                  <a class="del-pic-btn pic-btn" href="javascript: void(0)" v-show="picList[1].picture" @click="delPicFn(1)">删除图片</a>
                </div>
              </li>

              <li class="item" @click="picUploadFn($event, 2)">
                <div class="item-pic-box">
                  <img class="item-pic hook-item-pic upload-images" :src="picList[2].picture ? picList[2].picture : defaultPic" alt="游戏截图"/>
                  <vue-core-image-upload
                  v-show="!picList[2].picture"
                  class="btn btn-primary upload-pic-btn pic-btn"
                  text="上传图片"
                  @imageuploaded="imageuploaded"
                  @errorhandle="errorhandle"
                  :data="picData"
                  :maxFileSize="1048576"
                  inputOfFile="FileName"
                  extensions="jpg"
                  inputAccept="image/jpg,image/jpeg"
                  crop="local"
                  :maxWidth="800"
                  :maxHeight="450"
                  cropRatio="16:9"
                  :url="`${$api.upload}/Developer/UploadFile`" >
                  </vue-core-image-upload>
                  <a class="del-pic-btn pic-btn" href="javascript: void(0)" v-show="picList[2].picture" @click="delPicFn(2)">删除图片</a>
                </div>
              </li>

              <li class="item" @click="picUploadFn($event, 3)">
                <div class="item-pic-box">
                  <img class="item-pic hook-item-pic upload-images" :src="picList[3].picture ? picList[3].picture : defaultPic" alt="游戏截图"/>
                  <vue-core-image-upload
                  v-show="!picList[3].picture"
                  class="btn btn-primary upload-pic-btn pic-btn"
                  text="上传图片"
                  @imageuploaded="imageuploaded"
                  @errorhandle="errorhandle"
                  :data="picData"
                  :maxFileSize="1048576"
                  inputOfFile="FileName"
                  extensions="jpg"
                  inputAccept="image/jpg,image/jpeg"
                  crop="local"
                  :maxWidth="800"
                  :maxHeight="450"
                  cropRatio="16:9"
                  :url="`${$api.upload}/Developer/UploadFile`" >
                  </vue-core-image-upload>
                  <a class="del-pic-btn pic-btn" href="javascript: void(0)" v-show="picList[3].picture" @click="delPicFn(3)">删除图片</a>
                </div>
              </li>
            </ul>

            <ul class="pic-list-box pic-list2 clearfix">
              <li class="item" @click="picUploadFn($event, 4)">
                <div class="item-pic-box">
                  <img class="item-pic hook-item-pic upload-images" :src="picList[4].picture ? picList[4].picture : defaultPic" alt="游戏截图"/>
                  <vue-core-image-upload
                  v-show="!picList[4].picture"
                  class="btn btn-primary upload-pic-btn pic-btn"
                  text="上传图片"
                  @imageuploaded="imageuploaded"
                  @errorhandle="errorhandle"
                  :data="picData"
                  :maxFileSize="1048576"
                  inputOfFile="FileName"
                  extensions="jpg"
                  inputAccept="image/jpg,image/jpeg"
                  crop="local"
                  :maxWidth="800"
                  :maxHeight="450"
                  cropRatio="16:9"
                  :url="`${$api.upload}/Developer/UploadFile`" >
                  </vue-core-image-upload>
                  <a class="del-pic-btn pic-btn" href="javascript: void(0)" v-show="picList[4].picture" @click="delPicFn(4)">删除图片</a>
                </div>
              </li>

              <li class="item" @click="picUploadFn($event, 5)">
                <div class="item-pic-box">
                  <img class="item-pic hook-item-pic upload-images" :src="picList[5].picture ? picList[5].picture : defaultPic" alt="游戏截图"/>
                  <vue-core-image-upload
                  v-show="!picList[5].picture"
                  class="btn btn-primary upload-pic-btn pic-btn"
                  text="上传图片"
                  @imageuploaded="imageuploaded"
                  @errorhandle="errorhandle"
                  :data="picData"
                  :maxFileSize="1048576"
                  inputOfFile="FileName"
                  extensions="jpg"
                  inputAccept="image/jpg,image/jpeg"
                  crop="local"
                  :maxWidth="800"
                  :maxHeight="450"
                  cropRatio="16:9"
                  :url="`${$api.upload}/Developer/UploadFile`" >
                  </vue-core-image-upload>
                  <a class="del-pic-btn pic-btn" href="javascript: void(0)" v-show="picList[5].picture" @click="delPicFn(5)">删除图片</a>
                </div>
              </li>

              <li class="item"></li>
            </ul>
          </div>
        </div>

        <p class="on-line-info">
          您的测试区版本上线日期：2017-10-31  1:00:00
          <span>版本号：{{ mapVersion }}</span>
        </p>

        <p class="errot-desc">{{ formErrot }}</p>

        <div class="submit-examine">
          <a class="submit-examine-btn" href="javascript: void(0)" @click="mapSubexamine">提交审核</a>
        </div>
      </form>
    </div>

    <!--遮罩层组件开始-->
    <v-basic-mask ref="basicMask" :show="maskFlag" @closeMaskEv="closeMaskFn">
      <span slot="desc">{{ uploadPicTps }}</span>
    </v-basic-mask>
    <!--遮罩层组件结束-->
  </section>
</template>

<script type="text/ecmascript-6">
  // 引入用户登录信息组件
  import loginInfo from 'components/loginInfo/loginInfo'
  // 图片上传组件
  import VueCoreImageUpload from 'vue-core-image-upload'
  // ajax 请求插件
  import Axios from 'axios'
  // 引入 cookie插件
  import VueCookie from 'vue-cookie'
  // 用户信息相关操作
  import {delUserCookie} from 'assets/js/user'
  // 遮罩提示层
  import basicMask from 'components/basicMask/basicMask'
  const ERROR_TIPS = [
    { desc: '表单验证失败' },
    { desc: '最少上传3张游戏截图' },
    { desc: '网络错误' },
    { desc: '请上传游戏主图' }
  ]

  export default {
    // 测试区地图审核页面
    name: 'devMapinspect',
    data () {
      return {
        // 遮罩层
        maskFlag: false,
        // 上传图片时的错误信息
        uploadPicTps: '',
        // loading 加载层开关
        imageLoadingFlag: false,
        // 地图版本信息
        mapVersion: '',
        // 游戏类型
        mapType: 1,
        // 地图信息
        mapInfo: '',
        // 地图id
        mapId: this.$route.params.mapId,
        // 地图进行阶段
        stage: this.$route.params.stage,
        // 请求地图信息接口
        apiPath: '',
        // 地图标签
        tags: [],
        // 添加地图标标签输入框默认值
        tagVal: '',
        // 地图名称
        mapName: '',
        // 地图描述
        mapDesc: '',
        // 地图更新内容
        mapUpdate: '',
        // 图片demo1
        demoFlag1: false,
        // 图片demo2
        demoFlag2: false,
        // 表单错误信息
        formErrot: '',
        // 表单数据
        formDatas: {
          // 用户id
          userId: VueCookie.get('UserID'),
          // session id
          sessionId: VueCookie.get('SessionID')
        },
        // 默认显示图片
        defaultPic: '/static/img/default-image.png',
        // 上传图片信息列表
        picList: [
          {picture: ''},
          {picture: ''},
          {picture: ''},
          {picture: ''},
          {picture: ''},
          {picture: ''}
        ],
        // 图片上传参数列表
        picData: {
          // 用户id
          UserID: '',
          // session id
          SessionID: '',
          // 地图进度阶段id
          Stage: '',
          // 地图 id
          MapStageId: '',
          // 地图索引
          PictureIndex: '',
          // 上传地图后要替换的图片位置
          picReplace: ''
        }
      }
    },
    computed: {
      // 地图标签输入框 显示\隐藏 标志
      tagAddFlag () {
        if (this.tags.length >= 3) {
          return false
        } else {
          return true
        }
      },
      // 计算上传图片的数量
      countPicList () {
        let tempArr = []
        // 过滤
        this.picList.forEach((item, index) => {
          // 跳过游戏主图
          if (index !== 0) {
            if (item.picture !== '') {
              tempArr.push(item)
            }
          }
        })
        // 返回过滤后数组的长度
        return tempArr.length
      }
    },
    created () {
      this.init()
    },
    methods: {
      // 初始化数据
      init () {
        // 实例化表单对象
        let formData = new FormData()
        // 将用户名添加到表单
        formData.append('UserID', this.formDatas.userId)
        // 将密码添加到表单
        formData.append('SessionID', this.formDatas.sessionId)
        // 地图id
        formData.append('MapId', this.mapId)
        // 请求地图详细信息 api
        Axios.post(`${this.$api.root}/Developer/GetMapDevInfo`, formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            switch (res.Code) {
              case 0:
                // 将地图信息赋值到对象属性
                this.mapInfo = res.DevInfo
                // 游戏主图
                this.picList[0].picture = this.mapInfo.MainPicture
                // 获取图片默认地址
                this.picList[1].picture = this.mapInfo.Picture1
                this.picList[2].picture = this.mapInfo.Picture2
                this.picList[3].picture = this.mapInfo.Picture3
                this.picList[4].picture = this.mapInfo.Picture4
                this.picList[5].picture = this.mapInfo.Picture5
                // 设置地图当前进行阶段的id
                this.picData.MapStageId = this.mapInfo.Id
                // 设置图片上传时的地图进行阶段id
                this.picData.Stage = this.stage
                // 地图描述信息
                this.mapDesc = this.mapInfo.Note
                // 地图更新内容
                this.mapUpdate = this.mapInfo.UpdateContent
                // 地图版本你信息
                this.mapVersion = this.mapInfo.MapVersion
                // 如果标签不是为空
                if (this.mapInfo.MapTag !== null) {
                  // 将字符串拆分成数组
                  this.tags = this.mapInfo.MapTag.split(',')
                }
                break
              case 1:
                // 删除登录信息
                delUserCookie()
                this.$router.push({name: 'login'})
                break
              default:
                console.log(res.Code)
                console.log(res.Msg)
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      // 图片上传回调函数
      imageuploaded (res) {
        switch (res.Code) {
          case 0:
            // 关闭图片上传 loading 加载层
            this.imageLoadingFlag = false
            // 将返回的图片地址设置到图片上
            this.picReplace[0].src = res.ImgUrl
            // 对数组中的图片信息进行赋值
            this.picList[this.picData.PictureIndex].picture = res.ImgUrl
            // 清空错误信息
            this.formErrot = ''
            break
          case 1:
            // 删除登录信息
            delUserCookie()
            this.$router.push({name: 'login'})
            break
          case 2:
            // this.uploadPicTps = res.Msg
            // 弹出提示层
            // this.maskFlag = true
            this.formErrot = res.Msg
            break
          default:
            // 其他错误
            this.formErrot = res.Msg
            console.log(res.Code)
            console.log(res.Msg)
        }
      },
      // 图片上传过程中
      imageuploading () {
        // 打开 loading 加载层
        this.imageLoadingFlag = true
      },
      // 文件上传时出现错误
      errorhandle (error) {
        // 检查错误
        switch (error) {
          case 'FILE IS TOO LARGER MAX FILE IS 1.00MB':
            this.uploadPicTps = '文件大小不能超过1M'
            break
          case 'access_denied':
            this.uploadPicTps = '网络错误'
            break
          default:
            this.uploadPicTps = error
        }
        // 弹出错误提示
        this.maskFlag = true
      },
      // 关闭错误提示层
      closeMaskFn () {
        this.maskFlag = false
      },
      // 点击上传图片时设置参数
      picUploadFn (event, index) {
        // 设置图片索引
        this.picData.PictureIndex = index
        // 设置上传参数用户id
        this.picData.UserID = this.formDatas.userId
        // 设置上传参数 session id
        this.picData.SessionID = this.formDatas.sessionId
        // 上传后替换图片的位置
        this.picReplace = event.currentTarget.getElementsByClassName('hook-item-pic')
      },
      // 删除图片
      delPicFn (index) {
        // 实例化表单对象
        let formData = new FormData()
        // 将用户名添加到表单
        formData.append('UserID', this.formDatas.userId)
        // 将密码添加到表单
        formData.append('SessionID', this.formDatas.sessionId)
        // 地图进行阶段
        formData.append('Stage', this.picData.Stage)
        // 地图进行阶段id
        formData.append('MapStageId', this.picData.MapStageId)
        // 图片索引
        formData.append('PictureIndex', index)
        // 请求地图详细信息 api
        Axios.post(`${this.$api.upload}/Developer/DeleteMapPicture`, formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            switch (res.Code) {
              case 0:
                // 清空图片信息
                this.picList[this.picData.PictureIndex].picture = ''
                break
              case 1:
                // 删除登录信息
                delUserCookie()
                this.$router.push({name: 'login'})
                break
              default:
                console.log(res.Code)
                console.log(res.Msg)
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      // 添加地图标签
      addTagFn () {
        // 清空输入内容的空格
        let tag = this.tagVal.trim()
        // 如果地图标签有内容输入
        if (tag !== '') {
          // 添加到数组
          this.tags.push(this.tagVal)
          // 清空输入框
          this.tagVal = ''
          // 获取输入框焦点
          this.$refs.addTagInput.focus()
        }
      },
      // 删除地图标签
      delTagFn (index) {
        // console.log(index)
        this.tags.splice(index, 1)
      },
      // 地图提交审核
      mapSubexamine () {
        this.$validator.validateAll().then(() => {
          // 表单是否有错误信息
          let isError = this.errors.any()
          if (isError) {
            // 获取所有错误信息的数组列表
            let formErrors = this.$validator.errors.all()
            // 返回第一个错误信息
            this.formErrot = formErrors[0]
          } else {
            if (this.picList[0].picture !== '') {
              // 判断上传游戏截图的数量
              if (this.countPicList >= 3) {
                // 实例化表单对象
                let formData = new FormData()
                // 将用户名添加到表单
                formData.append('UserID', this.formDatas.userId)
                // 将密码添加到表单
                formData.append('SessionID', this.formDatas.sessionId)
                // 地图id
                formData.append('MapId', this.mapId)
                // 地图名称
                formData.append('MapName', this.mapName)
                // 地图进行阶段
                formData.append('Stage', this.picData.Stage)
                // 地图标签
                formData.append('MapTag', this.tags.join(','))
                // 地图进行阶段id
                formData.append('MapStageId', this.picData.MapStageId)
                // 地图类型
                formData.append('MapType', this.mapType)
                // 地图描述
                formData.append('Note', this.mapDesc)
                // 更新内容
                formData.append('UpdateContent', this.mapUpdate)
                // 地图版本
                formData.append('MapVersion', this.mapInfo.MapVersion)
                // 请求地图详细信息 api
                Axios.post(`${this.$api.root}/Developer/SubmitAuditDev`, formData, {
                  // 设置请求为表单提交
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  }
                }).then((response) => {
                  // http 请求成功
                  if (response.status === 200) {
                    // 获取接口数据
                    let res = response.data
                    switch (res.Code) {
                      case 0:
                        // 跳转到审核中页面
                        this.$router.push({name: 'toExamine', params: {mapId: this.mapId, stage: this.stage}})
                        break
                      case 1:
                        // 删除登录信息
                        delUserCookie()
                        this.$router.push({name: 'login'})
                        break
                      default:
                        console.log(res.Code)
                        console.log(res.Msg)
                    }
                  }
                }).catch((error) => {
                  this.formErrot = ERROR_TIPS[2].desc
                  console.log(error)
                })
              } else {
                // 提示上传图片数量的信息
                this.formErrot = ERROR_TIPS[1].desc
              }
            } else {
              // 提示上传游戏主图
              this.formErrot = ERROR_TIPS[3].desc
            }
          }
        }).catch(() => {
          this.formErrot = ERROR_TIPS[0].desc
        })
      },
      // demo图示1
      demo1Fn () {
        this.demoFlag1 = !this.demoFlag1
      },
      // demo图示2
      demo2Fn () {
        this.demoFlag2 = !this.demoFlag2
      }
    },
    components: {
      'v-login-info': loginInfo,
      'vue-core-image-upload': VueCoreImageUpload,
      'v-basic-mask': basicMask
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "pubMapinspect.styl";
</style>



// WEBPACK FOOTER //
// src/views/pubMapinspect/pubMapinspect.vue